import type { LevelDefinition } from '../world/LevelDefinition';
import { TEST_CHAMBER } from './test-chamber';
import { DECK7 } from './deck7';
import { JUNCTION_12 } from './junction12';
import { JEFFERIES } from './jefferies';
import { SHUTTLE_BAY } from './shuttle-bay';
import { REACTOR_GALLERY } from './reactor-gallery';
import { OUTER_HULL } from './outer-hull';
import { FIRING_RANGE } from './firing-range';
import { PRESSURE_CORRIDOR } from './pressure-corridor';
import { GAUNTLET } from './gauntlet';
import { COMPONENT_GALLERY } from './component-gallery';

/**
 * The playable campaign, in order.
 *
 * The difficulty showcase: Firing Range, Pressure Corridor and Gauntlet each
 * carry a `difficulty` tag, so they are where the harder burst cadences and the
 * chaotic spread live. Component Gallery is the one deck authored with the map
 * builder — its `compileMap` output is the level — so the toolchain ships with
 * the game rather than only existing behind a menu.
 */
export const LEVEL_CATALOG: LevelDefinition[] = [
  TEST_CHAMBER,
  DECK7,
  JUNCTION_12,
  JEFFERIES,
  SHUTTLE_BAY,
  REACTOR_GALLERY,
  OUTER_HULL,
  FIRING_RANGE,
  PRESSURE_CORRIDOR,
  GAUNTLET,
  COMPONENT_GALLERY,
];

export function getLevel(id: string | null | undefined): LevelDefinition {
  if (!id) return LEVEL_CATALOG[0];
  return LEVEL_CATALOG.find((level) => level.id === id) ?? LEVEL_CATALOG[0];
}
